export const UPDATE_NAME = 'UPDATE_NAME';
const updatePerson = {type: 'UPDATE_NAME', payload: 'New Emulya', data: ''};
export default updatePerson;
